<template>
    <section class="reg-temp-content-area main-content-height p-5">
        <RepairSubNav />
        <SearchAndDateRange :s.sync="s" :startDate.sync="startDate" :endDate.sync="endDate" @filter-click="buildQueryAndSearch(1)" />
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <pagination class="mt-0" :pagenavs="pageNavs" :currentpage="currentPage" :callback="fetchPage"></pagination>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-12 text-center" v-if="loading">
                <loading />
            </div>

            <div class="text-center col-sm-12 col-md-12" v-if="!loading && loadCount == 1 && filtered_registered_products.length < 1">
                <p>
                    No Product found starting from <strong>{{ startDate }} to {{ endDate }}</strong>
                </p>
            </div>

            <template v-if="!loading">
                <div
                    class="col-sm-12 col-md-6 col-lg-4 col-xl-3"
                    v-bind:key="'product_' + index"
                    v-for="(product, index) in filtered_registered_products"
                >
                    <productItem :type="'distributor'" :editcallback="editCallBack" :deletecallback="deleteCallBack" :product="product" />
                </div>
            </template>

            <div class="col-sm-12 col-md-12 col-lg-12">
                <pagination class="mt-0" :pagenavs="pageNavs" :currentpage="currentPage" :callback="fetchPage"></pagination>
            </div>
        </div>
    </section>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import Pagination from '@/components/Pagination';
import {mapGetters, mapActions} from 'vuex';
import Helpers from '@/helpers/index';
import * as _ from 'lodash';
import moment from 'moment';
import RepairSubNav from '@/views/distributor/pageComponents/RepairSubNav.vue';
import SearchAndDateRange from '@/views/distributor/pageComponents/SearchAndDateRange.vue';

export default {
    name: 'registerProductList',
    components: {
        Pagination,
        RepairSubNav,
        SearchAndDateRange
    },
    data() {
        return {
            loading: false,
            active_ticket: 'active',
            s: '',
            startDate: moment().subtract(3, 'months').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            pdfdata: '',
            loadCount: 0,
            currentPage: 1,
            pageNavs: [],
            filtered_registered_products: [],
            hasActiveFilter: false
        };
    },
    created() {},
    computed: {
        ...mapGetters({
            vg_loggedIn_user_id: 'auth/userid'
        })
    },
    watch: {},
    mounted() {
        this.buildQueryAndSearch(1);
    },
    methods: {
        /**
         * Build query and search
         */
        buildQueryAndSearch: _.debounce(function (page = 1) {
            this.currentPage = page;
            let queryObj = {};
            queryObj['status'] = 'closed';
            // then search text
            if (this.s) {
                queryObj['s'] = this.s;
            }
            if (this.startDate) {
                queryObj['startDate'] = this.startDate;
            }
            if (this.endDate) {
                queryObj['endDate'] = this.endDate;
            }
            let urlquery = Helpers.buildQueryStringFromObj(queryObj);
            this.fetchRegProducts('&' + urlquery);
        }, 50),

        async fetchRegProductsMain(urlquery) {
            const url = `${Env.baseUrl}/v2/distributor/reg-product/get-repair-products?page=${this.currentPage + urlquery}`;
            return await AuthApis.getApi(url)
                .then((res) => {
                    this.loadCount = 1;
                    this.filtered_registered_products = res.data.payload;
                    this.pageNavs = res.data.nav;
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        async fetchRegProducts(urlquery) {
            this.loading = true;
            await this.fetchRegProductsMain(urlquery);
            this.loading = false;
        },

        /**
         * Fetch page data
         */
        fetchPage(pageNo) {
            this.currentPage = pageNo;
            this.buildQueryAndSearch(this.currentPage);
        },

        viewCocCertificate(obj) {
            this.va_pdfModal(true);
            this.va_pdfModalObj(obj);
        },
        /**
         * Delete record
         */
        deleteCallBack(product) {
            this.$confirm({
                title: `DELETE?`,
                message: 'Are you sure you want to delete ' + product.sku_with_serial_number,
                button: {
                    no: 'No',
                    yes: 'Yes'
                },
                callback: (confirm) => {
                    if (confirm) {
                        const url = `${Env.baseUrl}/distributor/reg-product/delete/${product.id}`;
                        AuthApis.deleteApi(url)
                            .then(async (res) => {
                                this.buildQueryAndSearch(this.currentPage);
                                this.$toasted.global.success({
                                    message: 'Successfully deleted.'
                                });
                            })
                            .catch((err) => {
                                this.$toasted.global.error({
                                    message: 'Failed, please try again later.'
                                });
                            });
                    }
                }
            });
        },

        /**
         * Update ticket status
         */
        updateTicketStatus(pid, sts) {
            this.spinner(true);
            const url = `${Env.baseUrl}/distributor/reg-product/update-ticket-status/${pid}`;
            AuthApis.postApi(url, {
                open_ticket: this.active_ticket == 'active' ? 0 : 1
            })
                .then((res) => {
                    this.spinner(false);
                    this.$toasted.global.success({
                        message: 'Successfully ' + this.active_ticket ? ' revoked.' : ' activated.'
                    });
                    this.buildQueryAndSearch(this.currentPage);
                })
                .catch((err) => {
                    this.spinner(false);
                    console.log(err);
                    this.$toasted.global.error({
                        message: 'Failed, please try again later.'
                    });
                });
        },

        readAbleTime(str) {
            if (str == '' || str == undefined) {
                return '';
            }
            return moment(str).format('YYYY-MM-DD hh:mm a');
        },

        /**
         * editCallBack
         */
        editCallBack(product) {
            this.$router.push({
                name: 'DistributorRegisteredProductEdit',
                params: {
                    id: product.id
                }
            });
        },

        ...mapActions({
            va_pdfModal: 'pdf/setActive',
            va_pdfModalObj: 'pdf/setActiveObj'
        })
    }
};
</script>
